module.exports = __webpack_public_path__ + "img/graphic2.e26ff697.jpg";